const nextTick = (wait?: number) => new Promise<void>((resolve) => {
  setTimeout(resolve, wait || 0);
});

export default nextTick;
